// extracted by mini-css-extract-plugin
export default {"icon":"gKOkVi","iconComponentContainer":"SVJZ5U"};